import { render, staticRenderFns } from "./reporte_memorando.vue?vue&type=template&id=2d3f36fe&scoped=true"
import script from "./reporte_memorando.vue?vue&type=script&lang=js"
export * from "./reporte_memorando.vue?vue&type=script&lang=js"
import style1 from "./reporte_memorando.vue?vue&type=style&index=1&id=2d3f36fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f36fe",
  null
  
)

export default component.exports